<!--
  Bordero Page — small Diakonix sub-modal that asks for the carrier
  name before generating the borderò PDF.
  Redesigned 2026-06-12 (v2.7.0, Phase 1.5 Chunk D.4).

  Drops kendo-dialog + ~25 inline styles. Diakonix modal--sm pattern
  (max-width 480px, z-index 2050 above parent modals).
-->

@if (openedBorder) {
  <div class="modal-backdrop" (click)="close()">
    <aside
      class="modal modal--sm"
      role="dialog"
      aria-labelledby="bordero-page-title"
      (click)="$event.stopPropagation()"
    >

      <header class="modal__header">
        <h2 class="modal__title" id="bordero-page-title">
          📑 Generazione Borderò
        </h2>
        <button
          type="button"
          class="modal-close"
          (click)="close()"
          aria-label="Chiudi"
        >×</button>
      </header>

      <form
        class="modal__body"
        (ngSubmit)="submitForm()"
      >
        <p class="modal__hint">
          Inserisci il <strong>nome del corriere</strong> per generare il
          borderò degli ordini selezionati.
        </p>

        <div class="form-field">
          <label class="form-field__label" for="bp-courier">
            Nome corriere <span class="form-field__req">*</span>
          </label>
          <input
            id="bp-courier"
            type="text"
            class="form-input"
            placeholder="Es. SDA Express, Bartolini, …"
            [(ngModel)]="answer"
            name="answer"
            required
            autofocus
          />
        </div>
      </form>

      <footer class="modal__footer">
        <button
          type="button"
          class="btn btn--ghost"
          (click)="close()"
        >Annulla</button>
        <button
          type="button"
          class="btn btn--success"
          (click)="submitForm()"
          [disabled]="!answer?.trim()"
        >✓ Crea Borderò</button>
      </footer>

    </aside>
  </div>
}
